import type { AnalyticsObject, AnalyticsProperties } from '../types'

export type CurrencyPairParams = {
  currencyFrom: { iso: string }
  currencyTo: { iso: string }
}

export interface CurrencyPairProperties extends AnalyticsProperties {
  corridor: {
    currencyFrom: string
    currencyTo: string
    currencies: string
  }
}

export class CurrencyPair implements AnalyticsObject {
  name: string
  properties: CurrencyPairProperties
  constructor(properties: CurrencyPairProperties) {
    this.name = 'CurrencyPair'
    this.properties = properties
  }

  static getInstance(params: CurrencyPairParams) {
    return new CurrencyPair({
      corridor: {
        currencyFrom: params.currencyFrom.iso,
        currencyTo: params.currencyTo.iso,
        currencies: `${params.currencyFrom.iso}-${params.currencyTo.iso}`,
      },
    })
  }
}
